import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,

} from '@angular/router';
import {environment} from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WwwRedirectGuard implements CanActivate {

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
      if (environment.forceRedirectToWWW && window.location.hostname.indexOf('localhost') === -1) {
        if (window.location.hostname.indexOf('www.') === -1) {
          window.location.href = window.location.href.replace(window.location.hostname, 'www.' + window.location.hostname);
        }
      }
      return true;
    }
}
